module.exports =function nullify(x, n=1){
    if(x===0 || x==='0' || !x)
    return ""
    else return x*n
  }
